// extracted by mini-css-extract-plugin
export var searchHeader = "_81-0";
export var searchHeaderDark = "_81-1";